import { render, staticRenderFns } from "./PdSettingsCard.vue?vue&type=template&id=e4541308&scoped=true&"
import script from "./PdSettingsCard.vue?vue&type=script&lang=js&"
export * from "./PdSettingsCard.vue?vue&type=script&lang=js&"
import style0 from "./PdSettingsCard.vue?vue&type=style&index=0&id=e4541308&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4541308",
  null
  
)

export default component.exports